module.exports = __webpack_public_path__ + "img/motor.e6c2ff2a.gif";